import React from "react";
import { Button } from "@mui/material";
import { Image } from "mui-image";

import { ReactComponent as APPLY } from "../../assets/images/send.svg";
// import { ReactComponent as APPLY } from "../../assets/images/apply-icon.svg";
import PLACEHOLDER from "../../assets/images/profile-placeholder.svg";
import RIGHTARROW from "../../assets/images/right-arrow.svg";
import BADGE from "../../assets/images/badge.svg";
import GIFONE from "../../assets/lotties/request-one.json";
import GIFTWO from "../../assets/lotties/request-two.json";
import { MainContext } from "../../utils/context";
import { LottieWrapper } from "../../components/LottieWrapper";
// import { apiCall } from "../../utils/helpers";

export default function GetAccessView({
  data = {},
  selectedSubTypes = [],
  getAccessHandler = () => {},
  brandName = "",
  centreName = "",
  selectedType = {},
}) {
  const { categories } = React.useContext(MainContext);
  const ismobile = window.innerWidth <= 768;
  return (
    <>
      <div className="request-get-access-wrapper">
        <div className="request-user-img">
          <Image
            src={data.user_profile_image || PLACEHOLDER}
            alt=""
            height="100%"
            width="100%"
            fit="cover"
            duration={800}
          />
        </div>
        <span className="request-user-name">
          {selectedType.admin_type_id === 2 ? (
            <>{brandName}</>
          ) : selectedType.admin_type_id === 3 ? (
            <>{centreName}</>
          ) : (
            <>{data.first_name || data.name}</>
          )}
        </span>

        <div className="request-user-types">
          {selectedSubTypes.length > 0
            ? selectedSubTypes.map((a) => (
                <div className="request-user-type">{a.category_name}</div>
              ))
            : data.category_ids?.map?.((id) => (
                <div key={id} className="request-user-type">
                  {
                    categories.find?.((c) => c.category_id === id)
                      ?.category_name
                  }
                </div>
              ))}
        </div>
        <span
          style={{
            display: "block",
            width: "100%",
            // height: "2px",
            paddingBottom: "2px",
            background:
              "linear-gradient(180deg, rgba(223, 224, 226, 0) 0%, #DFE0E2 50%, rgba(223, 224, 226, 0) 100%)",
          }}
        ></span>

        <div
          style={{
            padding: "5%",
            // borderTop: "1px solid #DFE0E2",
            // border: "1.12px solid",
            // borderImage:
            //   "linear-gradient(180deg, rgba(223, 224, 226, 0) 0%, #DFE0E2 50%, rgba(223, 224, 226, 0) 100%)",
          }}
        >
          <div
            style={{
              borderRadius: 12,
              background:
                "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
              padding: 1,
            }}
          >
            <div
              style={{
                // backgroundColor: "#fff",
                background:
                  "radial-gradient(99.17% 99.17% at 50% 50%, #434343 0%, #121212 100%)",
                borderRadius: 12,
                color: "#CFCFCF",
                padding: "2% 5%",
              }}
            >
              {["Your new business account", "Business Banking"].map((a, i) => (
                <>
                  <div
                    key={a}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // margin: i === 0 ? "1rem 0.5rem 0rem 0.5rem" : "1rem 0.5rem",
                      margin: "1rem 0.5rem",
                    }}
                  >
                    <div
                      style={{
                        height: "3.6rem",
                        width: "3.6rem",
                        borderRadius: "2rem",
                        marginRight: "0.8rem",
                        backgroundColor: "beige",
                      }}
                    >
                      <LottieWrapper
                        animationData={i === 0 ? GIFONE : GIFTWO}
                      />
                    </div>
                    <div
                    // style={{
                    //   borderBottom: i === 0 ? "1.12267px solid #DFE0E2" : null,
                    // }}
                    >
                      <span style={{ fontSize: "0.95em", fontWeight: "500" }}>
                        {a}
                      </span>
                      <div
                        style={{
                          color: "#fff",
                          // boxShadow: "0px 4px 4px #FFE9E0",
                          borderRadius: 20,
                          padding: "0.2rem 0.8rem",
                          fontSize: "0.75em",
                          backgroundColor: "#ff4a01",
                          width: "max-content",
                          textTransform: "uppercase",
                        }}
                      >
                        Processing
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
          {data.is_kyc !== 1 ? (
            <div
              style={{
                marginTop: "1.5rem",

                borderRadius: 12,
                background:
                  "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                padding: 1,
              }}
            >
              <div
                style={{
                  // backgroundColor: "#fff",
                  borderRadius: 12,
                  padding: "3%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  color: "#CFCFCF",
                  background:
                    "radial-gradient(99.17% 99.17% at 50% 50%, #434343 0%, #121212 100%)",
                }}
              >
                <div style={{ textAlign: "left" }}>
                  <span style={{ fontSize: "1.2em", fontWeight: "700" }}>
                    Steps to Verify
                  </span>
                  <p style={{ margin: 0, fontSize: "0.9em" }}>
                    KYC Documents & Certifications
                  </p>
                </div>
                <div
                  onClick={getAccessHandler}
                  style={{
                    backgroundColor: "#FFFFFF",
                    color: "#FF4A01",
                    borderRadius: 8,
                    cursor: "pointer",
                    padding: "12px 20px",
                  }}
                >
                  <APPLY
                    style={
                      {
                        // width: "1.25rem",
                        // height: "1.25rem",
                        // width: "1.25rem",
                      }
                    }
                  />
                  <p style={{ margin: "-0.3rem 0", fontSize: "0.8em" }}>
                    Apply
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                marginTop: "1.5rem",

                borderRadius: 12,
                background:
                  "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                padding: 1,
              }}
            >
              <div
                style={{
                  background:
                    "radial-gradient(99.17% 99.17% at 50% 50%, #434343 0%, #121212 100%)",
                  borderRadius: 12,
                  padding: "5%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ width: 45 }}>
                  <Image src={BADGE} width={31} />
                </div>
                <div style={{ textAlign: "left", width: "100%" }}>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 16,
                      fontWeight: 700,
                      color: "#222831",
                    }}
                  >
                    You are now verified
                  </p>
                  <p
                    style={{
                      margin: "5px 0 14px 0",
                      fontSize: 13,
                      fontWeight: 400,
                      color: "#6F7379",
                    }}
                  >
                    Go to Dopamine app and grow your business
                  </p>
                  <a
                    href="https://onelink.to/5z9d3p"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "#FF4A01",
                      fontSize: 18,
                      fontWeight: 500,
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Download App Now
                    <Image
                      src={RIGHTARROW}
                      width={14}
                      style={{ marginRight: -8, marginTop: 4 }}
                    />
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          // background: "linear-gradient(274.73deg, #222831 1.48%, #6F7379 100%)",
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          padding: data.is_invited === 0 ? "1rem" : "1.5rem 1rem",
          display: "flex",
          alignItems: "center",
        }}
      >
        {data?.is_waitlisted === 1 ? (
          <Button
            id="step-7-onboarding-exclusive-access"
            style={{
              // marginTop: "1.6rem",
              marginBottom: "1rem",
              fontSize: "1em",
              fontWeight: "bold",
              paddingTop: "16px",
              paddingBottom: "16px",
              background:
                "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",

              color: "#FF4A01",
            }}
            fullWidth
            variant="contained"
            size="large"
            onClick={getAccessHandler}
            // fullWidth
            // variant="contained"
            // size="large"
            // style={{ padding: "16px 0", fontSize: "1em" }}
          >
            Get Exclusive Access
          </Button>
        ) : (
          <>
            <span
              className="request-footer-text"
              style={{ fontSize: ismobile ? 16 : 20 }}
            >
              Download the app and get exclusive access
            </span>
            <Button
              id="step-7-onboarding-access"
              style={{
                flex: 1,
                padding: "16px 0",
                fontSize: "1em",
                background:
                  "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
                color: "#FF4A01",
              }}
              // onClick={getAccessHandler}
              onClick={() =>
                (document.location.href = "https://onelink.to/5z9d3p")
              }
              fullWidth
              variant="contained"
            >
              Get Access
            </Button>
          </>
        )}
        {/* {data.is_invited === 0 ? (
          <Button
            id="step-7-onboarding-exclusive-access"
            onClick={getAccessHandler}
            fullWidth
            variant="contained"
            size="large"
            style={{ padding: "16px 0", fontSize: "1em" }}
          >
            Get Exclusive Access
          </Button>
        ) : (
          <>
            <span className="request-footer-text">
              Download the app and get exclusive access
            </span>
            <Button
              id="step-7-onboarding-access"
              style={{ flex: 1, padding: "16px 0", fontSize: "1em" }}
              onClick={getAccessHandler}
              fullWidth
              variant="contained"
            >
              Get Access
            </Button>
          </>
        )} */}
      </div>
    </>
  );
}

// export default GetAccessView;
